const oidc = {
    logout_success: 'Sessão terminada com sucesso.', // TRANSLATED
};
export default oidc;
